export default __webpack_public_path__ + "static/media/health.ce961ce9.webp";